import {html} from 'lit-html';
import {ifDefined} from 'lit-html/directives/if-defined';
import {live} from 'lit-html/directives/live';
import {classMap} from 'lit-html/directives/class-map';

import TemplateRegistry from '../template/template-registry';
import {
    valueSync, optionClassMap, optionName, inputColorSupported
} from '../template/template-util.js';

TemplateRegistry.templates['color'] = (option, config, onChange) => html`
    ${inputColorSupported() ?
    html`
     <input type="color" class="cl-po--input ${classMap(optionClassMap(option))}" id="${option.id}" name="${optionName(option)}" .value=${live(option.value)} @change=${(e) => valueSync(e, option, onChange)}
     ?required=${option.required} minlength=${ifDefined(option.params.min)} maxlength=${ifDefined(option.params.max)} placeholder=${ifDefined(option.params.placeholder)} form=${ifDefined(config.productFormLink)}>
        `: 
    TemplateRegistry.templates['color_input'](option,config,onChange)
    }
`;